import { api } from '../utils/data-utils';
import type { FetchFormResponse } from './types';

export const fetchScsPanelReportRecords = async (
  token: string,
  formIds: string[],
  year: string,
): Promise<FetchFormResponse[]> => {
  const ids = [...new Set(formIds)];
  const records: FetchFormResponse[] = [];
  for (let index = 0; index < ids.length; index += 50) {
    const batch = ids.slice(index, index + 50);
    const response = await api(token, '/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ report_type: 'scs_panel_report', form_ids: batch, year }),
    });
    const result = await response.json();
    const rows: FetchFormResponse[] = result?.records;
    if (
      !Array.isArray(rows) ||
      rows.length !== batch.length ||
      new Set(rows.map((row) => row?.formId)).size !== batch.length ||
      rows.some((row) => !batch.includes(row?.formId || '') || !row?.answers)
    ) {
      throw new Error('Report responses are missing or have changed. Refresh and try again.');
    }
    records.push(...rows);
  }
  return records;
};
